export const windowGlobal = () => window as any;
